"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeError = serializeError;
function serializeError(err) {
  if (err instanceof Error) {
    return {
      name: err.name || 'Error',
      message: err.message || 'No message',
      stack: err.stack ?? 'No stack trace'
    };
  }
  return {
    name: 'UnknownError',
    message: 'Unknown server-side error occurred',
    stack: ''
  };
}
